import React, {useState} from "react";
import {useSelector} from "react-redux";
import Auth from "../../helpers/auth";
import SchuelerEdit from "../../newForms2/schueler/SchuelerEdit";
import SchuelerNew from "../../newForms2/schueler/SchuelerNew";
import SchuelerButtons from "./SchuelerButtons";
import SchuelerDetails from "./SchuelerDetails";
import SchuelerList from "./SchuelerList";

const SchuelerMain = () => {
  const [view, setView] = useState("buttons");
  const [activeId, setActiveId] = useState(null);
  const currentUser = useSelector(st => st.currentUser);

  console.log({activeId});

  const props = {view, setView, activeId, setActiveId};
  return (
    <div className="my-5">
      {Auth.isDeveloper(currentUser.userStatus) ? <h1>{activeId}</h1> : null}
      {view === "formNew" && <SchuelerNew setView={setView} />}
      {view === "buttons" && <SchuelerButtons setView={setView} />}
      {view === "buttons" && <SchuelerList props={props} />}
      {view === "details" && <SchuelerDetails props={props} />}
      {view === "formEdit" && <SchuelerEdit setView={setView} activeId={activeId} />}
    </div>
  );
};
export default SchuelerMain;
